<template>
    <div class="w-full">
        <span class="loader w-full lg:w-1/2"></span>
    </div>
</template>

<style scoped>
.loader {
  height: 215px;
  display: block;
  margin: auto;
  position: relative;
  background: #FFF;
  box-sizing: border-box;
}
.loader::after {
  content: '';
  width: calc(100% - 30px);
  height: calc(100% - 15px);
  top: 15px;
  left: 15px;
  position: absolute;
  background-image: 
    linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5) 50%, transparent 100%),
    linear-gradient(#DDD 100px, transparent 0),
    linear-gradient(#DDD 16px, transparent 0),
    linear-gradient(#DDD 50px, transparent 0);
  background-repeat: no-repeat;
  background-size: 25% 175px, 100% 100px, 100% 16px, 100% 30px;
  background-position: -150% 0, center 0, center 115px, center 142px;
  animation: animloader 1.2s linear infinite;
  box-sizing: border-box;
}

@keyframes animloader {
  100% {
    background-position: 150% 0, center 0, center 115px, center 142px;
  }
}


</style>